

export { Dialog } from './src/index';
export { decorate } from './src/dialog-decorator/dialog-decorator';
